import React, { useEffect, useState } from 'react';
import { Card, Table } from 'antd';
import { useLazyQuery } from '@apollo/client';

import { fetchUsersVehicles, getRouteUser } from '../../queries/homeQueries';
import localStorageService from '../../../../services/localStorageService';

const columns = [
  {
    title: 'Placa',
    dataIndex: 'licencePlate',
    key: 'licencePlate',
    render: (text) => <small>{text}</small>
  },
  {
    title: 'Nombre',
    dataIndex: 'displayName',
    key: 'displayName',
    width: 150,
    render: (text) => <small>{text}</small>
  }
];

export const UsersVehiclesList = (props) => {
  const { usersVehicles, setUsersVehicles, setSelectedUserVehicle, flag } = props;

  const [selectedWarehouse, setSelectedWarehouse] = useState(JSON.parse(localStorageService.get("selectedWarehouses"))?.warehouses);

  // Pagination State
  const [pagination, setPagination] = useState({ current: 1, pageSize: 5 });
  const [total, setTotal] = useState(0);

  const [getUsersVehicles, dataUserVehicles] = useLazyQuery(fetchUsersVehicles, { fetchPolicy: 'no-cache' });
  const [getRouteUserId, dataRouteUser] = useLazyQuery(getRouteUser, { fetchPolicy: 'no-cache' });
  const [currentUserVehicle, setCurrentuserVehicle] = useState();


  const [isCheckboxSelected, setIsCheckboxSelected] = useState(false);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);



  useEffect(() => {
    const warehouses = JSON.parse(localStorageService.get("selectedWarehouses"))?.warehouses;
    setSelectedWarehouse(warehouses);
  }, [flag]);

  useEffect(() => {
    getUsersVehicles();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getUsersVehicles({
      variables: {
        distributionCenterId: selectedWarehouse?.length > 0 ? selectedWarehouse : ["00000000-0000-0000-0000-000000000000"],
        limit: pagination.pageSize,
        offset: (pagination.current - 1) * pagination.pageSize
      }
    });


    if (dataUserVehicles.data && dataUserVehicles.data.userVehicle.length > 0 && props.selectedUserVehicle.length > 0 && props.selectedUserVehicle[0].userId !== currentUserVehicle) {
      const currentSelection = dataUserVehicles.data.userVehicle.filter((item) => item.userId === props.selectedUserVehicle[0].userId);
      //setSelectedUserVehicle(currentSelection[0]);
      setCurrentuserVehicle(props.selectedUserVehicle[0].userId);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.data, props.selectedUserVehicle, pagination, selectedWarehouse]);

  useEffect(() => {

    if (!dataUserVehicles.loading && dataUserVehicles.data && dataUserVehicles.data.userVehicle.length > 0) {
      let records = [];

      // eslint-disable-next-line
      dataUserVehicles?.data?.userVehicle.map((item) => {
        return records.push({
          key: item?.id,
          licencePlate: item?.vehicle && item?.vehicle?.licencePlate ? item?.vehicle?.licencePlate : 'N/A',
          displayName: item?.user?.displayName,
          phoneNumber: item?.user?.phoneNumber,
          identificationNumber: item?.user?.identificationNumber,
          capacity: item?.vehicle && item?.vehicle?.weight ? item?.vehicle?.weight : 0,
          userId: item?.userId,
          vehicleId: item?.vehicleId,
          orderQty: item?.assignedRoutes_aggregate?.aggregate?.count,
          lastLocation: item?.lastLocation,
          lastLocationTime: item?.updatedAt,
          assignedRoutes: item?.assignedRoutes,
          vehicle: item?.vehicle,
          createdAt: item?.createdAt,
          schedulingStartLocation: item?.schedulingStartLocation,
          headquarters: item?.user?.headquarters
        });
      });
      setUsersVehicles(records);

      if (dataUserVehicles.data.userVehicle_aggregate) {
        setTotal(dataUserVehicles.data.userVehicle_aggregate.aggregate.count);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUserVehicles.data, dataUserVehicles.loading]);

  useEffect(() => {
    const key = props.selectedUserVehicle?.[0]?.key;
    const next = key ? [key] : [];
    setSelectedRowKeys(next);
    setIsCheckboxSelected(next.length === 1);
  }, [props.selectedUserVehicle]);


  const rowSelection = {
    type: 'checkbox',        // 👈 se ve como checkbox
    selectedRowKeys,         // 👈 controlado
    // Cuando se hace click en una fila:
    // Cuando se hace click en una fila:
    onSelect: async (record, selected) => {

      if (selected) {
        try {
          const { data } = await getRouteUserId({ variables: { userId: record.userId } });
          const enhancedRecord = {
            ...record,
            assignedRoutes: data?.routes,
            assignedRoutes_aggregate: data?.routes_aggregate
          };

          setSelectedRowKeys([record.key]);          // solo 1
          setSelectedUserVehicle([enhancedRecord]);          // solo 1
          setCurrentuserVehicle(record.userId);
          setIsCheckboxSelected(true);
        } catch (error) {
          console.error("Error fetching route user:", error);
        }
      } else {
        setSelectedRowKeys([]);
        setSelectedUserVehicle([]);
        setCurrentuserVehicle('');
        setIsCheckboxSelected(false);
      }
    },
    // Evita seleccionar todas
    onSelectAll: () => {
      setSelectedRowKeys([]);
      setSelectedUserVehicle([]);
      setCurrentuserVehicle('');
      setIsCheckboxSelected(false);
    },
    // Si quieres cubrir también el caso de selección vía checkbox “bulk”:
    onChange: async (keys, rows) => {
      const lastKey = keys[keys.length - 1];
      if (lastKey) {
        const lastRow = rows.find(r => r.key === lastKey) || usersVehicles.find(r => r.key === lastKey);

        try {
          const { data } = await getRouteUserId({ variables: { userId: lastRow.userId } });

          const enhancedRecord = {
            ...lastRow,
            assignedRoutes: data?.routes,
            assignedRoutes_aggregate: data?.routes_aggregate
          };

          setSelectedRowKeys([lastKey]);
          setSelectedUserVehicle(enhancedRecord ? [enhancedRecord] : []);
          setCurrentuserVehicle(lastRow?.userId || '');
          setIsCheckboxSelected(true);
        } catch (error) {
          console.error("Error fetching route user:", error);
        }
      } else {
        setSelectedRowKeys([]);
        setSelectedUserVehicle([]);
        setCurrentuserVehicle('');
        setIsCheckboxSelected(false);
      }
    },
  };



  return (
    <section>
      <Table

        className={`children-table-4 ${isCheckboxSelected ? 'children-table-4-1' : ''}`}
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
        }}
        columns={columns}
        dataSource={usersVehicles}
        size="small"
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: total,
          onChange: (page, pageSize) => {
            setPagination({ current: page, pageSize });
          }
        }}
        loading={dataUserVehicles.loading}
      />
    </section>
  )

}
